import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import config from '../config';
import './LocalLicenseInput.css';

const LOCAL_LICENSE_UNLOCK_API = `${config.backendUrl}/api/local-license/unlock`;
const MAC_ADDRESS_API = `${config.backendUrl}/api/system/mac-address`;

export default function LocalLicenseInput({ onUnlocked }) {
  const [licenseCode, setLicenseCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [macAddress, setMacAddress] = useState('');

  useEffect(() => {
    let isMounted = true;

    axios.get(MAC_ADDRESS_API)
      .then((response) => {
        if (
          isMounted &&
          response.data?.status === 'success' &&
          response.data?.mac_address
        ) {
          setMacAddress(response.data.mac_address);
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, []);

  const handleUnlock = async (e) => {
    e.preventDefault();

    if (!licenseCode.trim()) {
      setMessage('라이센스 코드를 입력해주세요.');
      setMessageType('error');
      return;
    }

    setIsSubmitting(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await axios.post(LOCAL_LICENSE_UNLOCK_API, {
        license_code: licenseCode.trim(),
      });

      const okMessage =
        response?.data?.message || '라이센스 잠금이 해제되었습니다.';

      setMessage(okMessage);
      setMessageType('success');

      if (typeof onUnlocked === 'function') {
        onUnlocked();
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error || '라이센스 해제에 실패했습니다.';

      setMessage(errorMessage);
      setMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="license-page">
      <div className="license-dialog">
        <div className="license-mac-address">MAC: {macAddress || '-'}</div>

        <div className="license-title-row">
          <span className="license-warning-icon">⚠️</span>
          <h2>라이센스가 만료되었습니다.</h2>
        </div>

        <div className="license-description">
          <p>
            사용 기간이 종료되었습니다. 발급받으신 라이센스 코드를 입력 바랍니다.
          </p>
          <p>
            라이센스 코드가 없으시면 당사에 문의 부탁드립니다.
          </p>
        </div>

        <div className="license-contact">
          <span className="license-phone-icon">☎</span>
          <span>062-674-9916</span>
          <span className="license-time">(월~금 9:00~18:00)</span>
        </div>

        <Form onSubmit={handleUnlock} className="license-form">
          <Form.Control
            className="license-input"
            type="password"
            value={licenseCode}
            onChange={(e) => setLicenseCode(e.target.value)}
            disabled={isSubmitting}
            autoComplete="off"
            placeholder="라이센스 코드를 입력하세요"
          />

          <Button
            type="submit"
            className="license-confirm-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? '확인 중' : '확인'}
          </Button>
        </Form>

        {message && (
          <div className={`license-message ${messageType}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
